import React, { useEffect, useState } from 'react';
import axios from '../../../constents/axios';
import { Alert, Button, Form, Table } from 'react-bootstrap';

const subjectsList = [
  "Paper I",
  "Malayalam",
  "Computer Science",
  "Commerce",
  "Economics",
  "English",
  "History",
  "Sociology",
  "MCJ",
  "Psychology",
  "Management",
  "CSIR",
  "Other"   // ⭐ special option
];

const topicsBySubject = {
  "Paper I": [
    "Teaching aptitude",
    "Research aptitude",
    "Reading comprehension",
    "Communication",
    "Mathematical Reasoning",
    "Logical Reasoning",
    "Data Interpretation",
    "Information and communication technology",
    "People development and environment",
    "Higher education",
  ],
  "Malayalam": [
    "മലയാളസാഹിത്യം പ്രാരംഭം",
    "ഇരുപതാം നൂറ്റാണ്ടുമുതലുള്ള മലയാളകവിത",
    "കഥാസാഹിത്യം",
    "ദൃശ്യകലയും സാഹിത്യവും",
    "നാടോടിവിജ്ഞാനീയം",
    "മലയാളനിരൂപണം",
    "മറ്റു സാഹിത്യവിഭാഗങ്ങൾ",
    "ഭാഷാശാസ്ത്രവും വ്യാകരണവും",
    "സാഹിത്യസിദ്ധാന്തങ്ങളും സൗന്ദര്യശാസ്ത്രവും",
    "കേരളസംസ്കാരം",
  ],
  "Computer Science": [
    "Unit 1. Discrete structures and optimization",
    "Unit 2 . Computer system architecture",
    "Unit 3. Programming language and computer graphics",
    "Unit 4. Database management system",
    "Unit 5. System software and Operating system",
    "Unit 6.Software engineering",
    "Unit 7. Data structures",
    "Unit 8. Theory of computation and compiler",
    "Unit 9. Data communication and computer network",
    "Unit 10. Artificial intelligence"
],
  "Commerce": [
    "UNIT 1: BUSINESS ENVIRONMENT AND INTERNATIONAL BUSINESS",
    "UNIT 2: ACCOUNTING AND AUDITING",
    "UNIT 3: BUSINESS ECONOMICS",
    "UNIT 4: BUSINESS FINANCE",
    "UNIT 5: BUSINESS STATISTICS AND RESEARCH METHODS",
    "UNIT 6: BUSINESS MANAGEMENT AND HUMAN RESOURCE MANAGEMENT",
    "UNIT 7: BANKING AND FINANCIAL INSTITUTIONS",
    "UNIT 8: MARKETING MANAGEMENT",
    "UNIT 9: LEGAL ASPECTS OF BUSINESS",
    "UNIT 10: INCOME-TAX AND CORPORATE TAX PLANNING"
],
  "Economics": [
    "Unit 1. Micro Economics",
    "Unit 2. Macro Economics",
    "Unit 3. Statistics and Econometrics",
    "Unit 4. Mathematical Economics",
    "Unit 5. International Economics",
    "Unit 6. Public Economics",
    "Unit 7. Money and Banking",
    "Unit 8. Growth and Development Economics",
    "Unit 9. Environmental Economics and Demography",
    "Unit 10. Indian Economy"
  ],
    "English": [
    "Unit 1: Early British Literature",
    "Unit 2: Romantic Age",
    "Unit 3: Victorian Age",
    "Unit 4: Modern Age",
    "Unit 5: Postmodern Age",
    "Unit 6: American Literature",
    "Unit 7: Indian English Literature",
    "Unit 8: Postcolonial Literature",
    "Unit 9: Other European Literature",
    "Unit 10: Linguistics",
    "Unit 11: Literary Criticism and Theory",
    "Unit 12: Research Methods and Materials in English"
  ],
    "History": [
    "UNIT 1 - Negotiating the Sources",
    "UNIT 2 - From State to Empire",
    "UNIT 3 - Emergence of Regional Kingdoms",
    "UNIT 4 - Sources of Medieval Indian History",
    "UNIT 5 - Administration and Economy",
    "UNIT 6 - Society and Culture",
    "UNIT 7 - Sources of Modern Indian History",
    "UNIT 8 - Colonial Economy",
    "UNIT 9 - Rise of Indian Nationalism",
    "UNIT 10 - Historiography"
  ],
    "Sociology": [
    "Unit 1 - Sociological Theories",
    "Unit 2 - Research Methods",
    "Unit 3 - Basic Concepts",
    "Unit 4 - Rural & Urban Transformations",
    "Unit 5 - State, Politics and Development",
    "Unit 6 - Economy and Society",
    "Unit 7 - Environment and Society",
    "Unit 8 - Family, Marriage and Kinship",
    "Unit 9 - Science, Technology and Kinship",
    "Unit 10 - Culture and Symbolic Interactionism"
  ],
    "MCJ": [
    "UNIT 1 - Introduction to Mass Communication & Journalism",
    "UNIT 2 - Communication for Development & Social Change",
    "UNIT 3 - Reporting & Editing",
    "UNIT 4 - Advertising & Marketing Communication",
    "UNIT 5 - Public Relations & Corporate Communication",
    "UNIT 6 - Media Laws & Ethics",
    "UNIT 7 - Media Management",
    "UNIT 8 - ICT & Media",
    "UNIT 9 - Film & Visual Communication",
    "UNIT 10 - Communication Research"
  ],
    "Psychology": [
    "Unit 1 – Emergence of Psychology",
    "Unit 2 – Research Methodology and Statistics",
    "Unit 3 – Psychological Testing",
    "Unit 4 – Biological Basis of Behavior",
    "Unit 5 – Attention, Perception, Learning, Memory and Forgetting",
    "Unit 6 – Thinking, Intelligence and Creativity",
    "Unit 7 – Personality, Motivation, Emotion, Stress and Coping",
    "Unit 8 – Social Psychology",
    "Unit 9 – Human Development and Interventions",
    "Unit 10 – Emerging Areas"
  ],
    "Management": [
    "Unit 1 - Business Management",
    "Unit 2 - Managerial Economics",
    "Unit 3 - Organisation Behaviour",
    "Unit 4 - Human Resource Management",
    "Unit 5 - Accounting",
    "Unit 6 - Financial Management",
    "Unit 7 - Strategic Management",
    "Unit 8 - Marketing",
    "Unit 9 - Statistics",
    "Unit 10 - Operations Management",
    "Unit 11 - International Business",
    "Unit 12 - Entrepreneurship Development"
  ],
    "CSIR": [
    "Unit 1 - Molecules and their Interactions Relevant to Biology",
    "Unit 2 - Cellular Organization",
    "Unit 3 - Fundamental Processes",
    "Unit 4 - Cell Signalling and Cell Communication",
    "Unit 5 - Developmental Biology",
    "Unit 6 - Plant Physiology",
    "Unit 7 - Animal Physiology",
    "Unit 8 - Inheritance Biology",
    "Unit 9 - Diversity of Lifeforms",
    "Unit 10 - Ecological Principles",
    "Unit 11 - Evolution and Animal Behaviour",
    "Unit 12 - Applied Biology",
    "Unit 13 - Methods in Biology"
  ],
  "Other": ["Other"],
};


const AddQuestions = () => {
    const [questions, setQuestions] = useState([]);
    const [batchId, setBatchID] = useState("");
    const [questionNo, setQuestionNo] = useState("");
    const [question, setQuestion] = useState("");
    const [option1, setOption1] = useState("");
    const [option2, setOption2] = useState("");
    const [option3, setOption3] = useState("");
    const [option4, setOption4] = useState("");
    const [rightAnswer, setRightAnswer] = useState("");
    const [explanation, setExplanation] = useState("");
    const [topic, setTopic] = useState("");
    const [subTopic, setSubTopic] = useState("");
    const [successMessage, setSuccessMessage] = useState(false); // State for success message
    const [subject, setSubject] = useState("");
    const [topicInputEnabled, setTopicInputEnabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const fetchLatestQuestions = async (batchId = "") => {
        try {
            const response = await axios.get(`/tests/getLatestQuestion/${batchId}`, {
                headers: {
                    'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
                },
            });
            setQuestions(response.data);
        } catch (error) {
            console.error('Error fetching latest questions:', error);
        }
    };

    useEffect(() => {
        fetchLatestQuestions();
    }, []);

    useEffect(() => {
        if (batchId.trim()) {
            fetchLatestQuestions(batchId);
        }
    }, [batchId]);

    const uploadQuestions = async () => {
      setIsSubmitting(true); // 🔄 start loader
        try {
            const response = await axios.post('/tests/addQuestion', {
                batchId,
                questionNo,
                question,
                option1,
                option2,
                option3,
                option4,
                rightAnswer,
                explanation,
                topic,
                subTopic,
            }, {
                headers: {
                    'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
                }
            });
            fetchLatestQuestions(batchId);
            setSuccessMessage(true); // Show success message
            setTimeout(() => setSuccessMessage(false), 3000); // Hide after 3 seconds
            setBatchID("");
            setQuestionNo("");
            setQuestion("");
            setOption1("");
            setOption2("");
            setOption3("");
            setOption4("");
            setRightAnswer("");
            setExplanation("");
            setTopic("");
            setSubTopic("");
        } catch (error) {
            console.error('Error uploading questions:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubjectChange = (value) => {
      setSubject(value);

      if (value === "Other") {
        setTopicInputEnabled(true); // allow user typing
        setTopic("");
      } else {
        setTopicInputEnabled(false);
        setTopic(""); // reset topic
      }
    };


    const styleImages = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        const images = div.querySelectorAll('img');
        images.forEach((img) => {
            img.style.maxWidth = '300px';
            img.style.height = 'auto';
        });
        return div.innerHTML;
    };

  return (
    <div>
      <div className="row">
        <h3 className="col-md-3">Add Questions</h3>
        {successMessage && (
          <Alert className="col-md-5 text-center" variant="success">
            Successfully Added
          </Alert>
        )}
      </div>
      <div className="row">
        <div className="col-md-6">
          <h5>Upload Questions</h5>
          <div
            style={{
              width: "100%",
              height: "80vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                uploadQuestions();
              }}
            >
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Batch ID</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={batchId}
                  onChange={(e) => setBatchID(e.target.value)}
                  placeholder="Enter Batch ID"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Question No:</Form.Label>
                <Form.Control
                  type="number"
                  value={questionNo}
                  required
                  onChange={(e) => setQuestionNo(e.target.value)}
                  placeholder="Enter Question No"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Question:</Form.Label>
                <Form.Control
                  as="textarea"
                  value={question}
                  required
                  onChange={(e) => setQuestion(e.target.value)}
                  rows={3}
                  placeholder="Enter Question"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Options 1:</Form.Label>
                <Form.Control
                  as="textarea"
                  value={option1}
                  required
                  rows={3}
                  onChange={(e) => setOption1(e.target.value)}
                  placeholder="Enter Option 1"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Options 2:</Form.Label>
                <Form.Control
                  as="textarea"
                  value={option2}
                  required
                  rows={3}
                  onChange={(e) => setOption2(e.target.value)}
                  placeholder="Enter Option 2"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Options 3:</Form.Label>
                <Form.Control
                  as="textarea"
                  value={option3}
                  required
                  rows={3}
                  onChange={(e) => setOption3(e.target.value)}
                  placeholder="Enter Option 3"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Options 4:</Form.Label>
                <Form.Control
                  as="textarea"
                  value={option4}
                  required
                  rows={3}
                  onChange={(e) => setOption4(e.target.value)}
                  placeholder="Enter Option 4"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Explanation:</Form.Label>
                <Form.Control
                  as="textarea"
                  value={explanation}
                  required
                  rows={3}
                  onChange={(e) => setExplanation(e.target.value)}
                  placeholder="Enter Explanation"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Right Answer:</Form.Label>
                <Form.Control
                  as="select"
                  value={rightAnswer}
                  required
                  onChange={(e) => setRightAnswer(e.target.value)}
                  placeholder="Enter Answer"
                >
                  <option value="">Select Right Answer</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Subject</Form.Label>
                <Form.Select
                  value={subject}
                  required
                  onChange={(e) => handleSubjectChange(e.target.value)}
                >
                  <option value="">Select Subject</option>
                  {subjectsList.map((sub, i) => (
                    <option key={i} value={sub}>
                      {sub}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {/* Topic Dropdown or Input */}
              <Form.Group className="mb-3">
                <Form.Label>Topic</Form.Label>

                {topicInputEnabled ? (
                  <Form.Control
                    type="text"
                    required
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                    placeholder="Enter Topic"
                  />
                ) : (
                  <Form.Select
                    value={topic}
                    required
                    onChange={(e) => setTopic(e.target.value)}
                  >
                    <option value="">Select Topic</option>

                    {subject &&
                      topicsBySubject[subject]?.map((t, i) => (
                        <option key={i} value={t}>
                          {t}
                        </option>
                      ))}
                  </Form.Select>
                )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>SubTopic:</Form.Label>
                <Form.Control
                  type="text"
                  value={subTopic}
                  required
                  onChange={(e) => setSubTopic(e.target.value)}
                  placeholder="Enter SubTopic"
                />
              </Form.Group>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Uploading...
                  </>
                ) : (
                  "Upload"
                )}
              </Button>
              `
            </Form>
          </div>
        </div>
        <div className="col-md-6">
          <h5>Latest Questions</h5>
          <div
            style={{
              width: "100%",
              height: "80vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Q.No</th>
                  <th>Question</th>
                  <th>Topic</th>
                  <th>SubTopic</th>
                </tr>
              </thead>
              <tbody>
                {questions.map((question, index) => (
                  <tr key={index}>
                    <td>{question.question_number}</td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: styleImages(question.question),
                      }}
                    ></td>
                    <td>{question.topic}</td>
                    <td>{question.subtopic}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddQuestions